import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia';
import { globalVuelidatePlugin } from './store/LeadValidator';
import { BasicAnalyticsService } from './services/BasicAnalyticsService';
import { FacebookPixelService } from './services/FacebookPixelService';
import { GoogleAnalyticsService } from './services/GoogleAnalyticsService';
import { getCookieConsentValue } from './helpers/CookieConsent';

// import compiled base styles scss and bootstrap-icons
import '@/assets/css/style.css';
import '@/assets/css/bs-icons/bootstrap-icons.css';

const app = createApp(App);
const pinia = createPinia();

app
  .use(pinia)
  .use(globalVuelidatePlugin)
  .use(router);

GoogleAnalyticsService.syncWithConsent(getCookieConsentValue());
FacebookPixelService.syncWithConsent(getCookieConsentValue());
BasicAnalyticsService.ensurePersistentClientId();
BasicAnalyticsService.submitOnFirstLoadIfUtmPresent();

app.mount('#app');
